import { useState, useEffect } from "react";
import { useNotificationSnackbar } from "../../../hooks/useNotificationSnackbar";
import { useTPClientService } from "../../../service/tpclient";
import { IOptionTree } from "../../../service/tpclient/interfaces/IOptionTree";

export const useOptionTree = (
  idTree: any
): [IOptionTree | null, boolean, () => void] => {
  const { getOptionTree } = useTPClientService();
  const [rows, setRows] = useState<IOptionTree| null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const { onErrorSnackbar } = useNotificationSnackbar();

  const fetch = async () => {
    try {
      if (idTree) {
        setLoading(true);
        const response = await getOptionTree(idTree);
        if (response.status === 200) {
          setRows(response.data);
          setLoading(false);
        } else {
          onErrorSnackbar(response.data);
          setLoading(false);
        }
      }
    } catch (error: any) {
      setRows(null);
      onErrorSnackbar(error);
      setLoading(false);
    }
  };

  const requestUpdate = () => {
    fetch();
  };

  useEffect(() => {
    fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idTree]);

  return [rows, loading, requestUpdate];
};
